export default function Shimmer(){
    return (
        <div className="w-[100%] container mx-auto flex flex-wrap justify-center gap-8 mt-5">
            {/* <h2 className="font-bold text-xl" >Restaurants with online food delivery in Delhi</h2> */}
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 w-[96%] text-center">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            
            {/* <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[97%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div> */}
            {/* <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div>
            <div className="w-[280px] my-3">
                <div className="w-68 h-46 rounded-xl bg-gray-300"> </div>
                <div className="mt-3 px-1 w-[96%]">
                    <div className="w-full h-6 bg-gray-300"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                    <div className="w-full h-6 bg-gray-300 mt-2"></div>
                </div>
            </div> */}
        </div>
    )
}